<header class="mb-5 mat-elevation-z8 menubar">
  <div class="container-fluid">
    <div class="row foobar">
      <div class="col-12">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6"><p class="mb-0 text-center whitetext"><mat-icon style="font-size: 15px;"> call</mat-icon> Customer Service: 0761-4045468</p></div>
          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6"><p class="mb-0 text-center whitetext"><mat-icon style="font-size: 15px;"> phone_iphone</mat-icon> Phone: 9300100063</p></div>
          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6"><p class="mb-0 text-center whitetext"><mat-icon style="font-size: 15px;"> email</mat-icon> E-Mail: purenetbroadband@gmail.com</p></div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf='!small'>
        <div class="col-md-3 col-sm-12">
          <img src="../assets/p2.png" id="logoimg">
        </div>          
        <div class="col-md-9 col-sm-12 text-right">
          <div class="row">
            <div class="col-12">
              <button mat-raised-button class="ml-1 bluebtn" (click)='goHome()'>Home</button>
              <button mat-raised-button class="ml-1 bluebtn" (click)='goAbout()'>About Us</button>
              <button mat-raised-button class="ml-1 bluebtn" (click)='goServices()'>Services</button>
              <button mat-raised-button class="ml-1 bluebtn" (click)='goFeedback()'>Feedback</button>
              <button mat-raised-button class="ml-1 bluebtn" (click)='goContact()'>Contact Us</button>
              <button mat-raised-button class="ml-1 bluebtn" (click)='goOrders()'>Orders</button>
              <button mat-raised-button class="ml-1 bluebtn" (click)='goMyAccount()'>My Account</button>
              <button class="signin ml-3" mat-raised-button (click)='goSignIn()'>{{buttonName}}</button>
            </div>
          </div>
        </div>
    </div>
    <div class="row" *ngIf='small'>
      <div class="col-10">
        <div class="row"><div class="col-12"><img src="../assets/p2.png" id="logoimgs"></div></div>
      </div>
      <div class="col-2 pl-0 pr-0">
        <mat-menu #appMenu="matMenu">
            <button mat-raised-button class="ml-1 mb-2 mr-1 bluebtns" (click)='goHome()'>Home</button><mat-divider></mat-divider>
            <button mat-raised-button class="ml-1 mb-2 mr-1 mt-2  bluebtns" (click)='goAbout()'>About Us</button><mat-divider></mat-divider>
            <button mat-raised-button class="ml-1 mb-2 mr-1 mt-2  bluebtns" (click)='goServices()'>Services</button><mat-divider></mat-divider>
            <button mat-raised-button class="ml-1 mb-2 mr-1 mt-2  bluebtns" (click)='goFeedback()'>Feedback</button><mat-divider></mat-divider>
            <button mat-raised-button class="ml-1 mb-2 mr-1 mt-2  bluebtns" (click)='goContact()'>Contact Us</button><mat-divider></mat-divider>
            <button mat-raised-button class="ml-1 mb-2 mr-1 mt-2  bluebtns" (click)='goOrders()'>Orders</button><mat-divider></mat-divider>
            <button mat-raised-button class="ml-1 mb-2 mr-1 mt-2  bluebtns" (click)='goMyAccount()'>My Account</button><mat-divider></mat-divider>
            <button class="ml-1 mr-1 mt-2 signins" mat-raised-button (click)='goSignIn()'>{{buttonName}}</button>
        </mat-menu>
        
        <button class="menubtn" mat-icon-button [matMenuTriggerFor]="appMenu">
          <mat-icon style="font-size: 3rem;">menu</mat-icon>
        </button>
      </div>
    </div>
  </div>
</header>
    
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>

<br><br>

<div class="container-fluid foobar">
  <div class="row footext justify-content-center pt-3">
    <div class="col-md-3 col-sm-4 col-xs-12">
      <h3 style="border-bottom: 2px solid #02B1FF;">Contact Us</h3>
      <p><mat-icon style="color: #02B1FF; font-size: 20px;">place</mat-icon>Flat No. 02 Park Apartments, South Civil Lines, near I.G. Bungalow/Office, Jabalpur</p>
      <p><mat-icon style="color: #02B1FF; font-size: 20px;">phone_iphone</mat-icon>0761-4045468</p>
    </div>
    <div class="col-md-3 col-sm-4 col-xs-12">
      <h3 style="border-bottom: 2px solid #02B1FF;">Our Values</h3>
      <p>Our vision is to be a leading Broadband and IT services company, offering innovative products and solutions to home, enterprise and other customers</p>
    </div>
    <div class="col-md-3 col-sm-4 col-xs-12">
      <h3 style="border-bottom: 2px solid #02B1FF;">About Us</h3>
      <p>PureNet Telecom Services India Pvt. Ltd. is a Broadband Internet Services Provider company, for both personal and commercial use, based in Jabalpur, MP</p>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
      <h3 style="border-bottom: 2px solid #02B1FF;">Quick Contact</h3>
      <form class="planform" [formGroup]="exampleForm" novalidate (ngSubmit)="goSubmit(exampleForm.value)">
        <div class="row mb-2">
          <div class="col-12">
            <input placeholder="E-mail" class="form-control" formControlName="uname">
          </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <input placeholder="Phone Number" type="number" class="form-control" formControlName="phn">
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                  <textarea placeholder="Message" type="text" class="form-control" formControlName="message"></textarea>
            </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <button mat-raised-button class="signin" type="submit" [disabled]="!exampleForm.valid">Send</button>
          </div>
        </div>
    </form>
    </div>
    <div class="col-12 text-center">
      <div class="row justify-content-center">
        <div class="col-lg-3 col-sm-5 nopad">
          <p class="footext">Copyright &copy; PureNetIndia.com</p>
        </div>
        <div class="col-lg-2 col-sm-3 nopad">
          <p class="footext">All rights reserved.</p>
        </div>
        <div class="col-lg-3 col-sm-4 nopad">
          <p class="footext"><a href='#/termsnconditions'>Terms & Conditions</a></p>
        </div>
        <div class="col-lg-2 col-sm-4 nopad">
          <p class="footext"><a href='#/upolicy'>Usage Policy</a></p>
        </div>
        <div class="col-lg-2 col-sm-4 nopad">
          <p class="footext"><a href='#/ppolicy'>Privacy Policy</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
  